export { default as default } from './Descarrega';
